import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { FaRegEdit, FaFileExcel, FaRegTrashAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api.js";
import apiInstance from "../../../../Utils/api.js";
const LabServiceList = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);

  const [doctorID, setDoctorID] = useState("");
  const [showDoctor, setShowDoctor] = useState(true);
  const [showNurse, setShowNurse] = useState(false);
  const [showTherapist, setShowTherapist] = useState(false);
  const [doctorLists, setDoctorLists] = useState([]);
  const [therapistLists, setTherapistLists] = useState([]);
  const [nurseLists, setNurseLists] = useState([]);

  const [showDoctorBranch, setShowDoctorBranch] = useState(false);
  const [branchLists, setBranchesLists] = useState([]);
  const [relatedDoctorBranch, setRelatedDoctorBranch] = useState([]);
  const [filterDoctor, setFilterDoctor] = useState([]);

  const [relatedNurseBranch, setRelatedNurseBranch] = useState([]);
  const [nurseBranch, setNurseBranch] = useState(false);

  const [relatedTherapistBranch, setRelatedTherapistBranch] = useState([]);
  const [therapistBranch, setTherapistBranch] = useState(false);
  const [doctorEvent, setDoctorEvent] = useState("");
  const [nurseEvent, setNurseEvent] = useState("");
  const [theEvent, setTheEvent] = useState("");
  const [doctorSearch, setDoctorSearch] = useState([]);
  const [showDrSearch, setShowDrSearch] = useState(false);

  //Doctor's Branch Filter
  const handleDoctorBranch = (event) => {
    setDoctorEvent(event);
    console.log(event, "Doc ID");
    const getRelatedBranch = async () => {
      try {
        const res = await api.get("doctors");
        setRelatedDoctorBranch(
          res.data.data.filter(
            (el) => (el.relatedBranch ? el.relatedBranch._id : "") == event,
          ),
        );

        console.log(
          res.data.data.filter(
            (el) => (el.relatedBranch ? el.relatedBranch._id : "") == event,
          ),
          "reBranch",
        );
      } catch (err) {
        alert(err.message);
      }
    };

    getRelatedBranch();
  };

  const handleDoctorBranchShowHide = () => {
    // if (showDoctorBranch == 'true') {
    console.log(doctorEvent, "branch show hide ID");
    if (doctorEvent) {
      setShowDoctorBranch(true);
      setTherapistBranch(false);
      setShowDoctor(false);
      setShowTherapist(false);
      setShowNurse(false);
      setNurseBranch(false);
    } else {
      setShowDoctorBranch(false);
      setTherapistBranch(false);
      setShowDoctor(true);
      setShowTherapist(false);
      setShowNurse(false);
      setNurseBranch(false);
    }
    // } else {
    //   setShowDoctorBranch(true)
    //   setTherapistBranch(false)
    //   setShowDoctor(false)
    //   setShowTherapist(false)
    //   setShowNurse(false)
    //   setNurseBranch(false)
    // }
  };
  //Nurse's Branch Filter
  const handleNurseBranch = (event) => {
    setNurseEvent(event);
    console.log(event, "Branch ID");
    const getRelatedNurseBranch = async () => {
      try {
        const res = await api.get("nurses");
        setRelatedNurseBranch(
          res.data.data.filter(
            (el) => (el.relatedBranch ? el.relatedBranch._id : "") == event,
          ),
        );
        console.log(
          res.data.data.filter(
            (el) => (el.relatedBranch ? el.relatedBranch._id : "") == event,
          ),
          "Nur Branch",
        );
      } catch (err) {
        alert(err.message);
      }
    };
    getRelatedNurseBranch();

    setShowDoctorBranch(false);
    setNurseBranch(true);
    setShowDoctor(false);
    setShowNurse(false);
  };

  const handleNurseBranchShowHide = () => {
    if (nurseEvent) {
      setShowDoctorBranch(false);
      setTherapistBranch(false);
      setShowDoctor(false);
      setShowTherapist(false);
      setShowNurse(false);
      setNurseBranch(true);
    } else {
      setShowDoctorBranch(false);
      setTherapistBranch(false);
      setShowDoctor(false);
      setShowTherapist(false);
      setShowNurse(true);
      setNurseBranch(false);
    }
  };

  //Therapist's Branch Filter
  const handleTherapistBranch = (event) => {
    setTheEvent(event);
    console.log(event, "The Branch ID");
    const getRelatedTherapistBranch = async () => {
      try {
        const res = await api.get("therapists");
        setRelatedTherapistBranch(
          res.data.data.filter(
            (el) => (el.relatedBranch ? el.relatedBranch._id : "") == event,
          ),
        );
        console.log(
          res.data.data.filter(
            (el) => (el.relatedBranch ? el.relatedBranch._id : "") == event,
          ),
          "Thera Branch",
        );
      } catch (err) {
        alert(err.message);
      }
    };
    getRelatedTherapistBranch();

    // setTherapistBranch(true)
    // setShowDoctorBranch(false)
    // setNurseBranch(false)
    // setShowDoctor(false)
    // setShowNurse(false)
  };

  const handleTheBranchShowHide = () => {
    if (theEvent) {
      setShowDoctorBranch(false);
      setTherapistBranch(true);
      setShowDoctor(false);
      setShowTherapist(false);
      setShowNurse(false);
      setNurseBranch(false);
    } else {
      setShowDoctorBranch(false);
      setTherapistBranch(false);
      setShowDoctor(false);
      setShowTherapist(true);
      setShowNurse(false);
      setNurseBranch(false);
    }
  };

  // const url = 'https://backendcherryk.cherrykmyanmar.com:4000/api'
  const handleDelete = (event) => {
    console.log(event, "event");
    api
      .delete("doctor/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = doctorLists.filter((item) => item._id !== event);
        setDoctorLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleNurseDelete = (event) => {
    console.log(event, "event");
    api
      .delete("nurse/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = nurseLists.filter((item) => item._id !== event);
        setNurseLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleTheraDelete = (event) => {
    console.log(event, "event");
    api
      .delete("therapist/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = therapistLists.filter((item) => item._id !== event);
        setTherapistLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data);
      _export.current.props.data.map(function (element, index) {
        element.date = element.date.split("T")[0];
      });
      _export.current.save();
    }
  };
  useEffect(() => {
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    const getDoctorLists = async () => {
      const res = await api.get("doctors");

      setDoctorLists(res.data.data);
      setDoctorID(res.data.data);
      console.log(res.data.data[5].relatedBranch._id, "d ID");
    };
    getDoctorLists();

    const getTherapistLists = async () => {
      const res = await api.get("therapists");

      setTherapistLists(res.data.data);
    };
    const getNurseLists = async () => {
      const res = await api.get("nurses");

      setNurseLists(res.data.data);
    };

    getDoctorLists();
    getNurseLists();

    getBranches();
    getTherapistLists();
  }, []);

  const handleDoctorSearch = (name) => {
    setDoctorSearch(
      doctorLists.filter((el) =>
        el.name.toLowerCase().includes(name.toLowerCase()),
      ),
    );
    // console.log(
    //   doctorLists.filter(
    //     el =>
    //       el.name
    //         .toLowerCase()
    //         .split(' ')
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    //         .join(' ') === name
    //   ),
    //   'dr search'
    // )
    if (name) {
      setShowDrSearch(true);
      setShowDoctorBranch(true);
      setTherapistBranch(false);
      setShowDoctor(false);
      setShowTherapist(false);
      setShowNurse(false);
      setNurseBranch(false);
    } else {
      setShowDrSearch(false);
      setShowDoctorBranch(true);
      setTherapistBranch(false);
      setShowDoctor(true);
      setShowTherapist(false);
      setShowNurse(false);
      setNurseBranch(false);
    }
  };
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">
                      Doctor-Clinic List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row card-header d-flex justify-content-between">
                <div className="col-md-4">
                  <div className="input-group" style={{ marginTop: "30px" }}>
                    <input
                      type="search"
                      className="form-control rounded"
                      id="search_code"
                      placeholder="Enter Doctor Name"
                      onChange={(e) => handleDoctorSearch(e.target.value)}
                    />
                    &nbsp;
                  </div>
                </div>

                <div
                  className="offset-3 col-md-3"
                  style={{ marginTop: "2.3em" }}
                >
                  <div className="form-group">
                    <select
                      name="currency"
                      id=""
                      className="form-control mt-1"
                      onchange="convert(this.value)"
                      // placeholder='Filter By Branches'
                      onChange={(e) => {
                        handleDoctorBranch(e.target.value);
                        handleNurseBranch(e.target.value);
                        handleTherapistBranch(e.target.value);
                      }}
                    >
                      <option hidden>Filter By Branches</option>

                      {branchLists.map((option) => (
                        <option value={option._id}>{option.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div class="card-body">
                {/* Export data in Excel */}
                {/* <ExcelExport data={expenseLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date"
                          title="Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="relatedBankAccount.name"
                          title="Bank Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedCashAccount.name"
                          title="Cash Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedAccounting.name"
                          title="Account"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport> */}
                {/* Export Data in Excel end */}
                <div className="row py-3 d-flex justify-content-between">
                  <div className="col-md-6">
                    <button
                      onClick={handleDoctorBranchShowHide}
                      className="btn btn-sm bg-gradient-gray"
                    >
                      Doctor Lists
                    </button>
                    &nbsp;
                    <button
                      onClick={handleNurseBranchShowHide}
                      className="btn btn-sm bg-gradient-gray "
                    >
                      Nurse Aid Lists
                    </button>
                    &nbsp;
                    <button
                      onClick={handleTheBranchShowHide}
                      className="btn btn-sm bg-gradient-gray "
                    >
                      Therapist Lists
                    </button>
                  </div>

                  <div className="offset-2 col-md-2">
                    <Link to="/doctor-reg" className="btn btn-sm btn-primary">
                      <i class="fas fa-plus"></i> &nbsp;Add
                    </Link>
                    &nbsp;
                    {/* <a href="/expense_type" class="btn btn-primary">
                              Expense Type
                            </a> */}
                    <button
                      type="button"
                      className="btn btn-sm btn-success"
                      onClick={excelExport}
                    >
                      <FaFileExcel />
                      &nbsp;Export
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div class="col-md-12 card px-3 py-3">
                    <div class="table-responsive text-black" id="slimtest2">
                      <table class="table table-hover" id="filter_date">
                        <thead class="bg-info text-white">
                          <tr>
                            <th>#</th>

                            {/* <th>Bank / Cash Account</th>  */}
                            <th>Name</th>

                            <th>Branch</th>

                            <th>Speciality</th>
                            <th>Treatment Unit Main</th>
                            <th>Commission</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        {showDrSearch &&
                          doctorSearch.map((reDoctor, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>

                                <td>{reDoctor.name ? reDoctor.name : ""}</td>
                                <td>
                                  {reDoctor.relatedBranch
                                    ? reDoctor.relatedBranch.name
                                    : ""}
                                </td>
                                <td>{reDoctor.speciality}</td>
                                <td>
                                  {reDoctor.treatmentUnitMain
                                    ? reDoctor.treatmentUnitMain
                                    : ""}
                                </td>
                                <td>
                                  {reDoctor.commission
                                    ? reDoctor.commission
                                    : ""}
                                </td>

                                <td className="text-center">
                                  <Link
                                    to={"/refDoctor/" + reDoctor._id}
                                    className="btn btn-sm btn-info"
                                  >
                                    Commission
                                  </Link>
                                  &nbsp;
                                  <Link
                                    to={"/dnt-update/" + reDoctor._id}
                                    className="btn btn-sm btn-warning text-light"
                                  >
                                    <FaRegEdit />
                                  </Link>
                                  &nbsp;
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={(e) => handleDelete(reDoctor._id)}
                                  >
                                    <FaRegTrashAlt />
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                        {showDoctorBranch && (
                          <>
                            {relatedDoctorBranch.map((reDoctor, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>

                                  <td>{reDoctor.name ? reDoctor.name : ""}</td>
                                  <td>
                                    {reDoctor.relatedBranch
                                      ? reDoctor.relatedBranch.name
                                      : ""}
                                  </td>
                                  <td>{reDoctor.speciality}</td>
                                  <td>
                                    {reDoctor.treatmentUnitMain
                                      ? reDoctor.treatmentUnitMain
                                      : ""}
                                  </td>
                                  <td>
                                    {reDoctor.commission
                                      ? reDoctor.commission
                                      : ""}
                                  </td>

                                  <td className="text-center">
                                    <Link
                                      to={"/refDoctor/" + reDoctor._id}
                                      className="btn btn-sm btn-info"
                                    >
                                      Commission
                                    </Link>
                                    &nbsp;
                                    <Link
                                      to={"/dnt-update/" + reDoctor._id}
                                      className="btn btn-sm btn-warning text-light"
                                    >
                                      <FaRegEdit />
                                    </Link>
                                    &nbsp;
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={(e) =>
                                        handleDelete(reDoctor._id)
                                      }
                                    >
                                      <FaRegTrashAlt />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                          </>
                        )}
                        {nurseBranch && (
                          <>
                            {relatedNurseBranch.map((reDoctor, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>

                                  <td>{reDoctor.name ? reDoctor.name : ""}</td>
                                  <td>
                                    {reDoctor.relatedBranch
                                      ? reDoctor.relatedBranch.name
                                      : ""}
                                  </td>
                                  <td>{reDoctor.speciality}</td>
                                  <td>
                                    {reDoctor.treatmentUnitMain
                                      ? reDoctor.treatmentUnitMain
                                      : ""}
                                  </td>
                                  <td>
                                    {reDoctor.commission
                                      ? reDoctor.commission
                                      : ""}
                                  </td>

                                  <td className="text-center">
                                    <Link
                                      to={"/refDoctor/" + reDoctor._id}
                                      className="btn btn-sm btn-info"
                                    >
                                      Commission
                                    </Link>
                                    &nbsp;
                                    <Link
                                      to={"/dnt-update/" + reDoctor._id}
                                      className="btn btn-sm btn-warning text-light"
                                    >
                                      <FaRegEdit />
                                    </Link>
                                    &nbsp;
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={(e) =>
                                        handleDelete(reDoctor._id)
                                      }
                                    >
                                      <FaRegTrashAlt />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                          </>
                        )}
                        {therapistBranch && (
                          <>
                            {relatedTherapistBranch.map((the, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>

                                  <td>{the.name ? the.name : ""}</td>
                                  <td>
                                    {the.relatedBranch
                                      ? the.relatedBranch.name
                                      : ""}
                                  </td>
                                  <td>{the.speciality}</td>
                                  <td>
                                    {the.treatmentUnitMain
                                      ? the.treatmentUnitMain
                                      : ""}
                                  </td>
                                  <td>
                                    {the.commission ? the.commission : ""}
                                  </td>

                                  <td className="text-center">
                                    <Link
                                      to={"/refDoctor/" + the._id}
                                      className="btn btn-sm btn-info"
                                    >
                                      Commission
                                    </Link>
                                    &nbsp;
                                    <Link
                                      to={"/dnt-update/" + the._id}
                                      className="btn btn-sm btn-warning text-light"
                                    >
                                      <FaRegEdit />
                                    </Link>
                                    &nbsp;
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={(e) => handleDelete(the._id)}
                                    >
                                      <FaRegTrashAlt />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                          </>
                        )}

                        {showDoctor && (
                          <>
                            {doctorLists.map((doctor, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>

                                  <td>{doctor.name ? doctor.name : ""}</td>
                                  <td>
                                    {doctor.relatedBranch
                                      ? doctor.relatedBranch.name
                                      : ""}
                                  </td>
                                  <td>{doctor.speciality}</td>
                                  <td>
                                    {doctor.treatmentUnitMain
                                      ? doctor.treatmentUnitMain
                                      : ""}
                                  </td>
                                  <td>
                                    {doctor.commission ? doctor.commission : ""}
                                  </td>

                                  <td className="text-center">
                                    <Link
                                      to={"/refDoctor/" + doctor._id}
                                      className="btn btn-sm bg-dark"
                                    >
                                      Com
                                    </Link>
                                    &nbsp;
                                    <Link
                                      to={"/dnt-update/" + doctor._id}
                                      className="btn btn-sm bg-dark"
                                    >
                                      <FaRegEdit />
                                    </Link>
                                    &nbsp;
                                    <button
                                      className="btn btn-sm bg-red"
                                      onClick={(e) => handleDelete(doctor._id)}
                                    >
                                      <FaRegTrashAlt />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                          </>
                        )}

                        {showTherapist && (
                          <>
                            {therapistLists.map((the, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>

                                  <td>{the.name ? the.name : ""}</td>
                                  <td>
                                    {the.relatedBranch
                                      ? the.relatedBranch.name
                                      : ""}
                                  </td>

                                  <td>{the.speciality}</td>
                                  <td>
                                    {the.treatmentUnitMain
                                      ? the.treatmentUnitMain
                                      : ""}
                                  </td>
                                  <td>
                                    {the.commission ? the.commission : ""}
                                  </td>

                                  <td className="text-center">
                                    <Link
                                      to={"/refthe/" + the._id}
                                      className="btn btn-sm btn-info"
                                    >
                                      Com
                                    </Link>
                                    &nbsp;
                                    <Link
                                      to={"/dnt-update/" + the._id}
                                      className="btn btn-sm btn-warning text-light"
                                    >
                                      <FaRegEdit />
                                    </Link>
                                    &nbsp;
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={(e) =>
                                        handleTheraDelete(the._id)
                                      }
                                    >
                                      <FaRegTrashAlt />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                          </>
                        )}
                        {showNurse && (
                          <>
                            {nurseLists.map((the, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>

                                  <td>{the.name ? the.name : ""}</td>
                                  <td>
                                    {the.relatedBranch
                                      ? the.relatedBranch.name
                                      : ""}
                                  </td>

                                  <td>{the.speciality}</td>
                                  <td>
                                    {the.treatmentUnitMain
                                      ? the.treatmentUnitMain
                                      : ""}
                                  </td>
                                  <td>
                                    {the.commission ? the.commission : ""}
                                  </td>

                                  <td className="text-center">
                                    <Link
                                      to={"/refnur/" + the._id}
                                      className="btn btn-sm btn-info"
                                    >
                                      Com
                                    </Link>
                                    &nbsp;
                                    <Link
                                      to={"/dnt-update/" + the._id}
                                      className="btn btn-sm btn-warning text-light"
                                    >
                                      <FaRegEdit />
                                    </Link>
                                    &nbsp;
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={(e) =>
                                        handleNurseDelete(the._id)
                                      }
                                    >
                                      <FaRegTrashAlt />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                          </>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* <CommissionDialog
                open={open}
                close={() => setOpen(false)}
                expenseLists={expenseLists}
                setExpenseLists={setExpenseLists}
              /> */}
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>

    </>
  );
};
export default LabServiceList;
